<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="acknowledgement">
<p style="margin-top: 70px;"><strong>MARGARET</strong></p>
<p style="text-indent: 0em;">Devoid of all thoughts, feelings, tears, laughter, and dreams; she was an empty shell.</p><br/>
<p style="text-align: center;">BREATHING</p>
<p style="text-align: center;">EXISTING</p><br/>
<p style="text-indent: 0em;">The net curtain slipped from her liver-spotted, gnarled hand. Slowly turning away, she hobbled back into the gloomy interior of the small, stuffy room.</p><br/>
<p style="text-indent: 0em;"><strong>JOSHUA</strong></p>
<p style="text-indent: 0em;">His young, brooding eyes sharply switched from a group of rowdy teenagers to a distant, lone figure as she approached the school gates and walked through. One day, he silently vowed, I am going to make this girl my wife.</p><br/>
<p style="text-indent: 0em;"><strong>ABIGAIL</strong></p>
<p style="text-indent: 0em;">From afar, she had spotted him as she had done yesterday, the day before yesterday, and a myriad of other mornings; always sitting in the same spot, furiously copying a mate’s homework while, surreptitiously, casting her an eye before, closing his exercise book, and joining his boisterous chums in a laugh and a bout of harmless play-fighting. Always the centre of attention, she mused. He was popular, confident, and too good-looking for his own good. Not her type at all. Abruptly, she looked away, lest, once more, he caught her eye. She certainly had no intention of being a fly in his web.</p><br/>
<p style="text-indent: 0em;">The bell rang.</p>
<p style="text-indent: 0em;">The playground was empty.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Section0001.vue?335ed19c